<div class="access-card" [class.expanded]="expanded">
  <div class="card-header" (click)="toggleExpanded()">
    <div class="card-title">
      <div
        class="title-icon"
        [class.success]="successfullyConnected"
        [class.info]="needsCloudFormationMigration || showMigrationDuringTest"
      >
        @if (successfullyConnected) {
          <svg lucideCheck></svg>
        }
        @if (needsCloudFormationMigration || showMigrationDuringTest) {
          <svg lucideArrowRightLeft></svg>
        }
        @if (
          !successfullyConnected && !needsCloudFormationMigration && !showMigrationDuringTest && accessType === 'source'
        ) {
          <svg lucideMapPin></svg>
        }
        @if (
          !successfullyConnected && !needsCloudFormationMigration && !showMigrationDuringTest && accessType === 'target'
        ) {
          <svg lucideLocateFixed></svg>
        }
        @if (
          !successfullyConnected &&
          !needsCloudFormationMigration &&
          !showMigrationDuringTest &&
          accessType === 'failback'
        ) {
          <svg lucideRotateCcw></svg>
        }
      </div>
      <div>
        <h3>{{ title }}</h3>
        <div class="card-subtitle">
          <code>{{ awsAccountId }}</code> / <code>{{ region }}</code>
        </div>
      </div>
    </div>
    <div class="card-actions">
      <div class="card-action" (click)="$event.stopPropagation()">
        @if (successfullyConnected) {
          <span class="success-badge"><svg lucideCircleCheck></svg> Connected</span>
        }
        @if (needsCloudFormationMigration || showMigrationDuringTest) {
          <span class="info-badge"><svg lucideInfo></svg> Action Required</span>
        }
        <!-- Access is already working, just on an older template. Keep Test Access
        alongside so the customer can verify after updating. -->
        @if (
          connectedOnOlderTemplate &&
          !successfullyConnected &&
          !needsCloudFormationMigration &&
          !showMigrationDuringTest
        ) {
          <span class="stale-badge">
            <svg lucideCircleAlert aria-hidden="true"></svg>
            Out of date
          </span>
        }
        @if (!successfullyConnected && !needsCloudFormationMigration && !showMigrationDuringTest) {
          <button
            class="arpio-button small-button"
            data-cy="test-access-button"
            [disabled]="testing"
            (click)="testButtonClick()"
          >
            @if (testing) {
              <svg lucideLoaderCircle class="lucide-spin"></svg> Testing...
            } @else {
              Test Access
            }
          </button>
        }
      </div>
      @if (expanded) {
        <svg lucideChevronDown class="chevron-icon"></svg>
      } @else {
        <svg lucideChevronRight class="chevron-icon"></svg>
      }
    </div>
  </div>

  <!-- Body: Not connected - needs setup -->
  @if (!successfullyConnected && !needsCloudFormationMigration && !showMigrationDuringTest) {
    <div class="card-body-wrapper" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
      <div class="card-body">
        <p class="instruction-text">
          @if (stackName) {
            @if (retryText && !testing) {
              <strong class="retry-text">{{ retryText }}</strong>
            }
            Update the CloudFormation stack <strong>{{ stackName }}</strong> with this template:
          } @else {
            @if (connectSuccess) {
              @if (retryText && !testing) {
                <strong class="retry-text">{{ retryText }}</strong>
              }
              Update the {{ uiService.productName }} CloudFormation stack with this template:
            } @else {
              @if (retryText && !testing) {
                <strong class="retry-text">{{ retryText }}</strong>
              }
              Create a new CloudFormation stack from this template:
            }
          }
        </p>
        <div class="command-block">
          <button class="copy-btn" [copy-clipboard]="templateUrl" (copied)="onCopied()">
            @if (copied) {
              <svg lucideCheck class="copy-check"></svg>
            } @else {
              <svg lucideCopy></svg>
            }
            {{ copied ? 'Copied' : 'Copy URL' }}
          </button>
          <pre><code>{{ templateName }}</code></pre>
        </div>
        <p class="help-text">
          <a [href]="templateUrl" target="_blank" class="download-link">
            <svg lucideDownload></svg> Download {{ templateName }}
          </a>
        </p>
      </div>
    </div>
  }

  <!-- Body: Needs CloudFormation migration (currently via StackSets) -->
  @if (needsCloudFormationMigration || showMigrationDuringTest) {
    <div class="card-body-wrapper" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
      <div class="card-body">
        <div class="info-message">
          <svg lucideInfo></svg>
          <span
            >Access is currently provided by StackSets. Deploy this CloudFormation template to switch to standalone
            management.</span
          >
        </div>
        <div class="notice-block">
          <div class="notice-text">
            @if (retryText && !testing) {
              <strong class="retry-text">{{ retryText }}</strong>
            }
            <span>After deploying the CloudFormation template, verify access is configured:</span>
          </div>
          <button
            class="arpio-button small-button"
            data-cy="test-access-button"
            [disabled]="testing"
            (click)="testButtonClick()"
          >
            @if (testing) {
              <svg lucideLoaderCircle class="lucide-spin"></svg> Testing...
            } @else {
              Test Access
            }
          </button>
        </div>
        <div class="command-block">
          <button class="copy-btn" [copy-clipboard]="templateUrl" (copied)="onCopied()">
            @if (copied) {
              <svg lucideCheck class="copy-check"></svg>
            } @else {
              <svg lucideCopy></svg>
            }
            {{ copied ? 'Copied' : 'Copy URL' }}
          </button>
          <pre><code>{{ templateName }}</code></pre>
        </div>
        <p class="help-text">
          <a [href]="templateUrl" target="_blank" class="download-link">
            <svg lucideDownload></svg> Download {{ templateName }}
          </a>
        </p>
      </div>
    </div>
  }

  <!-- Body: Successfully connected via CloudFormation -->
  @if (successfullyConnected) {
    <div class="card-body-wrapper" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
      <div class="card-body success-body">
        <div class="success-message">
          <svg lucideCircleCheck></svg>
          <span>Access configured via CloudFormation</span>
        </div>
      </div>
    </div>
  }
</div>
